// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"324":"ecc1ec7c","2173":"96e9759f","3173":"24ffd58b","3843":"d9731d76","5061":"351e10eb"}[chunkId] + ".chunk.css";
};